import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";
import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";

const userServices = {
  state: {
    countReaction: {
      like: [],
      follow: [],
      heart: [],
    },
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getReationCount(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/userServices/getReationCount",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            begin: new Date(payload.begin).getTime(),
            end: new Date(payload.end).getTime(),
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) this.setState({ countReaction: result.data });
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
  }),
};

export default userServices;
